function CartReload(data) {
  var container = document.getElementById('cart-table'),
      tT = document.getElementById('total-top'),
      c = document.querySelector('.cart-table-body'),
      tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top'),
      nC = htmlDocument.documentElement.querySelector('.cart-table-body'),
      nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);  
  container.querySelector('.full-form').classList.remove('hidden');
  container.querySelector('.empty-form').classList.add('hidden');
  Quantity(container);
  CartButtons();
}

// function CartChange(q,container) {
//   var header = document.querySelector('header'),
//       it = q.closest('.item'),
//       id = it.getAttribute('data-product-id'),
//       q =  it.querySelector('.item-qty').value,
//       iQ = it.querySelector('.item-qty'),
//       s = it.querySelector('.error'),
//       aB = document.getElementById('ajaxBusy'),
//       cTa = document.getElementById('cart-table'),
//       cC = document.querySelectorAll('.cartCountSelector'),
//       cT = document.querySelector('.cartTotalSelector'),
//       tT = document.getElementById('total-cart-top'),
//       c = document.querySelector('.cart-table-body'),
//       tC = document.getElementById('cart-total'),
//       tB = document.getElementById('total-cart-bottom'),
//       dC = document.querySelector('.discount-cart'),
//       aS = document.querySelector('.animate-section'),
//       cD = document.getElementById('cart-dropdown');
//   if (q != '') {
//     aB.style.display = 'block';
//   }
//   fetch(theme.routes_cart_change_url + '.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({'quantity': q,'id':id})
//   }).then(function(r) {
//     return r.json();
//   }).then(function(j) {
//     if (q != '') {
//       cC.forEach(function(c) {
//         c.textContent = j.item_count;
//       });
//       if (header) {
//         cT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
//         tT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
//       }
//       if (j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0) {
//         tC.innerHTML = Shopify.formatMoney(j.items_subtotal_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
//         dC.innerHTML = Shopify.formatMoney('-' + j.total_discount, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
//       }
//       tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
//     }    
//     if (j.item_count == 0) {
//       ShippingMsg();
//       cTa.querySelector('.full-form').classList.add('hidden');
//       cTa.querySelector('.empty-form').classList.remove('hidden');
//       aB.style.display = 'none';
//       if (theme.dropdown == true) {
//         document.querySelector('.cart-count-mobile').setAttribute('href', theme.routes_cart_url);
//         document.querySelector('.cart-count-mobile').classList.remove('void');
//       }
//       if (cD) {
//         cD.remove();
//       }
//     } else {
//       var x = theme.cart;
//       CartDrop(x);
//       document.dispatchEvent(new CustomEvent('cartItems', {
//         bubbles: true
//       }));
//       fetch(theme.routes_cart_url)
//       .then(response => response.text())
//       .then(data => {
//         if (q != '') {
//           if (q == 0) {
//             it.remove();
//           }
//           CartReload(data)
//           aB.style.display = 'none';
//         }        
//       }).catch(function(err) {
//         console.error('!: ' + err)
//       });
//     };
//   }).catch(function(err) {
//     console.error('!: ' + err)
//   });
// }

function CartChange(q, container) {
  var header = document.querySelector('header'),
      it = q.closest('.item'),
      id = it.getAttribute('data-product-id'),
      q = it.querySelector('.item-qty').value,
      iQ = it.querySelector('.item-qty'),
      s = it.querySelector('.error'),
      aB = document.getElementById('ajaxBusy'),
      cTa = document.getElementById('cart-table'),
      cC = document.querySelectorAll('.cartCountSelector'),
      cT = document.querySelector('.cartTotalSelector'),
      
      // The correct ID selectors that are in your HTML are updated here.
      tT = document.getElementById('total-top'), 
      c = document.querySelector('.cart-table-body'),
      tC = document.getElementById('cart-total'),
      tB = document.getElementById('total-bottom'), // Used 'total-bottom' as per HTML
      
      dC = document.querySelector('.discount-cart'),
      aS = document.querySelector('.animate-section'),
      cD = document.getElementById('cart-dropdown');

  if (q != '') {
    if (aB) aB.style.display = 'block';
  }

  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'quantity': q, 'id': id})
  }).then(function(r) {
    return r.json();
  }).then(function(j) {
    if (q != '') {
      if (cC) {
        cC.forEach(function(c) {
          c.textContent = j.item_count;
        });
      }
      if (header && cT) {
        cT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      if (tT) {
        tT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      if (j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0 && tC) {
        tC.innerHTML = Shopify.formatMoney(j.items_subtotal_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        if (dC) dC.innerHTML = Shopify.formatMoney('-' + j.total_discount, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      
      // Conditional checking whether an element exists or not (Failsafe)
      if (tB) {
        tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
    }    

    if (j.item_count == 0) {
      if (typeof ShippingMsg === "function") ShippingMsg();
      if (cTa) {
        var fullForm = cTa.querySelector('.full-form');
        var emptyForm = cTa.querySelector('.empty-form');
        if (fullForm) fullForm.classList.add('hidden');
        if (emptyForm) emptyForm.classList.remove('hidden');
      }
      if (aB) aB.style.display = 'none'; // The loader will stop here.
      
      if (theme.dropdown == true) {
        var mobileCart = document.querySelector('.cart-count-mobile');
        if (mobileCart) {
          mobileCart.setAttribute('href', theme.routes_url);
          mobileCart.classList.remove('void');
        }
      }
      if (cD) {
        cD.remove();
      }
    } else {
      var x = theme.cart;
      if (typeof CartDrop === "function") CartDrop(x);
      document.dispatchEvent(new CustomEvent('cartItems', {
        bubbles: true
      }));
      
      fetch(theme.routes_cart_url)
      .then(response => response.text())
      .then(data => {
        if (q != '') {
          if (q == 0 && it) {
            it.remove(); // The item will be removed.
          }
          CartReload(data);
          if (aB) aB.style.display = 'none'; // The loader will stop here.
        }        
      }).catch(function(err) {
        console.error('!: ' + err);
        if (aB) aB.style.display = 'none';
      });
    }
  }).catch(function(err) {
    console.error('!: ' + err);
    if (aB) aB.style.display = 'none';
  });
}

function CartButtons() {
  var container = document.getElementById('cart-table'),
      qB = container.querySelectorAll('.qtybtn');
  qB.forEach(function(q) {
    if (q.classList.contains('icon-plus')) {
      var qF = q.closest('.qtyOpt.form'),
          vV = qF.querySelector('.item-qty').value,
          vM = qF.querySelector('.item-qty').getAttribute('max');
    };
    setTimeout(function () {
      q.onclick = function(ev){
        if (vM && vM == vV) {
          return;
        }
        CartChange(q,container);
      }
    }, 1);
  })  
  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    let timeout;
    var vV = q.value,
        vM = q.getAttribute('max');
    q.addEventListener('keyup', function (e) {
      if (e.key == 'Tab' || e.key == 'Shift') return;
      var nV = q.value;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (vM && nV == vV && vM == nV) {
          return;
        }
        CartChange(q,container);
      }, 750);
    });
  });  
}

theme.CartPage = (function() {
  function CartPage(container) {
    var sectionId = container.getAttribute('data-section-id'),
        chk = container.getAttribute('data-check'),
        acb = container.querySelector('.additional-checkout-buttons');
    theme.cart = true;
    Quantity(container);
    if(chk == 'true'){      
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById('cart-terms').onclick = function(ev){
        if (this.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
          if (acb) {
            acb.classList.remove('hidden');
          }
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
          if (acb) {
            acb.classList.add('hidden');
          }
        }
      };
    };
    CartButtons(container);
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();

